module.exports = __webpack_public_path__ + "static/img/consumed.beead881.svg";